import { useEffect } from "react";

/**
 * iOS-safe body scroll lock with reference counting.
 * Multiple overlays can lock simultaneously — the body stays fixed until
 * all locks are released, then scroll position is restored.
 */
let lockCount = 0;
let savedScrollY = 0;

export function useScrollLock(locked: boolean) {
  useEffect(() => {
    if (!locked) return;
    if (lockCount === 0) {
      savedScrollY = window.scrollY;
      document.body.style.position = "fixed";
      document.body.style.top = `-${savedScrollY}px`;
      document.body.style.width = "100%";
    }
    lockCount += 1;
    return () => {
      lockCount -= 1;
      if (lockCount <= 0) {
        lockCount = 0;
        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.width = "";
        window.scrollTo(0, savedScrollY);
      }
    };
  }, [locked]);
}
